import React from "react";
import type { InputHTMLAttributes } from "react";

import classNames from "classnames/bind";

import styles from "./Switch.module.scss";

const cx = classNames.bind(styles);

export interface SwitchProps extends InputHTMLAttributes<HTMLInputElement> {
    defaultChecked?: boolean;
    valueLeft?: string;
    className?: string;
    switchLabels?: {
        active: { className: string; text: string };
        inactive: { className: string; text: string };
    };
    switchLabelsClassName?: string;
}

const Switch = React.forwardRef((props: SwitchProps, ref: any) => {
    const { className, switchLabels, switchLabelsClassName, ...attrs } = props;

    const Component = (
        <div className={cx("switch", className, { "switch--withLabels": !!switchLabels })}>
            <input
                ref={ref}
                id="toggle-switch"
                type="checkbox"
                className={cx("input")}
                {...attrs}
            />
            <label htmlFor="toggle-switch" className={cx("slider", "round")}>
                <span />
            </label>
        </div>
    );

    if (switchLabels) {
        return (
            <div className={cx("switchLabelsContainer")}>
                {switchLabels && (
                    <div className={cx(switchLabelsClassName, switchLabels.active.className)}>
                        {switchLabels.active.text}
                    </div>
                )}
                {Component}
                {switchLabels && (
                    <div className={cx(switchLabelsClassName, switchLabels.inactive.className)}>
                        {switchLabels.inactive.text}
                    </div>
                )}
            </div>
        );
    }

    return Component;
});

Switch.displayName = "Switch";

export default Switch;
